export class OrderRoutes {
  readonly root: string;
  readonly summary: string;
  readonly orderIdParam: string;

  constructor(basePath: string) {
    this.root = `${basePath}order`;
    this.summary = "summary";
    this.orderIdParam = ":orderId";
  }

  get basePath(): string {
    return `${this.root}/${this.orderIdParam}`;
  }

  get summaryPath(): string {
    return `${this.basePath}/${this.summary}`;
  }

  getSummaryUrl(orderId: string): string {
    return `${this.root}/${orderId}/${this.summary}`;
  }
}
